import { useConnect } from 'sb-redux-hook'
import useFeatures from 'sb-hooks/useFeatures'
import { constants } from 'common/helpers'


const useCanUsePrepaidPlans = (() => {
  const { [constants.features.prepaidPlansLandingPage]: isPrepaidPlansLandingPageEnabled } = useFeatures()

  const { isUpgradableForMonthlyPlan } = useConnect({
    isUpgradableForMonthlyPlan: 'models.subscription.isUpgradableForMonthlyPlan',
  })

  return isPrepaidPlansLandingPageEnabled && isUpgradableForMonthlyPlan
})


export default useCanUsePrepaidPlans
